import axios from 'axios'
import store from '../store'
// import { AUTH_LOGOUT } from '../store/actions/auth'

// const HTTP = axios.create()

export default function setup () {
  axios.interceptors.request.use(function (config) {
    const token = store.getters.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  }, function (err) {
    return Promise.reject(err)
  })

  axios.interceptors.response.use(undefined, function (err) {
    return new Promise(function (resolve, reject) {
      if (err.response.status === 401) {
        // if you ever get an unauthorized, logout the user
        // store.dispatch(AUTH_LOGOUT)
        // you can also redirect to /login if needed !
      }
      throw err
    })
  })
}

/*
HTTP.interceptors.response.use(undefined, function (err) {
  return new Promise(function (resolve, reject) {
    console.log(err.status)
    if (err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
      console.log('LOG OUT')
      console.log(this)
      // if you ever get an unauthorized, logout the user
      this.$store.dispatch(AUTH_LOGOUT)
    // you can also redirect to /login if needed !
    }
    throw err
  })
})

const token = localStorage.getItem('access_token')
if (token) {
  HTTP.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

export default HTTP
*/



// WEBPACK FOOTER //
// ./src/utils/interceptors.js